export const validateInputNumber = (
	value: number,
	minValue: number | null,
	maxValue: number | null
) => {
	if (isNaN(value)) return null;
	if (minValue !== null && value < minValue) return minValue;
	if (maxValue !== null && value > maxValue) return maxValue;
	return value;
};
